import { createSelector } from 'reselect';

const selectAutostartTV = state => state.autostartTV;

export const selectAutostartTVData = createSelector(
  selectAutostartTV,
  autostartTV => autostartTV.data,
);

export const selectIsAutostartTVEnabled = createSelector(
  selectAutostartTVData,
  data => data.isAutostartTVEnabled,
);
